import { RioEventFn } from '../types'

export const rioEvent: RioEventFn = (client, eventSpecs, config) => {
  const { stateUpdate, force = false, eventVersion } = config

  // Return a promise that resolves when the server has responded:
  return new Promise((resolve, reject) => {
    if (stateUpdate) {
      client.updateState(stateUpdate)
    }
    const { options, ...event } = eventSpecs
    const sendEventParams = {
      ...event,
      eventVersion,
      options: { force, ...options },
    }
    client.sendEvent(sendEventParams).then(resolve).catch(reject)
  })
}
